/**
 * External dependencies
 */
import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { Row } from "react-bootstrap"

/**
 * Internal dependencies
 */
import "./styles/_index.scss"
import VideoPlaceholder from "../video-placeholder/video-placeholder"
import { isMobile } from "../../lib/media"
import { ShowProcessedImage } from '../common/ggfx-client/module/components/show-image';
import imageConfig from "../../../static/images/config.json"
import NoImage from "../../images/no-image.png"

const PropertyItem = ({
  propertyid,
  status,
  price,
  location,
  description,
  bedroomsCount,
  receptionsCount,
  bathroomsCount,
  propertyVideo,
  propertyImages1,
  propertyImages2,
  propertyDetailsLink,
  propertySearchType,
  propertyTitle,
  noResulttag
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const data = useStaticQuery(graphql`
    query MyQuery4 {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(jpeg)|(png)/" }
          dir: { regex: "property-item/images/" }
          name: { eq: "1" }
        }
      ) {
        edges {
          node {
            childrenImageSharp {
              fluid {
                src
              }
            }
          }
        }
      }
    }
  `)

  //property description
  let text_truncate = function(str, length, ending) {
    //
    // var $win = $(window);

    // if ( $win.width() <= 1500 ) {
    //     if (length == null) {
    //         length = 100;
    //     }
    // } else if ( $win.width() >= 1500 ) {
    //     if (length == null) {
    //         length = 220;
    //     }
    // }

    length = 150;
    //

    if (ending == null) {
      ending = '...';
    }
    
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  };
  //property description
  return (
    <div className="property-item-wrapper">
      <div className="property-item" data-aos="fade-up">
        <div className={noResulttag === "noResultsProperty" ? "shell px-0" : "shell"}>
          <Row className="property-item__row">
            <div className="property-item__row-inner">
              {status == "Sold Subject To Contract" &&
                <div className="flagprop">Under Offer</div>
              }
              {status == "Let Agreed" &&
                <div className="flagprop">Let Agreed</div>
              }
              <div className="property-item__gallery d-md-grid">
              <Link to={propertyDetailsLink} className="feat-img-wrap">
                {
                  noResulttag === "noResultsProperty" ? 
                  <div className="gatsby-image-wrapper featured-image fromalg1">
                    <picture >
                      <img src={propertyImages1 && propertyImages1[0]?.url} alt= {location + ' - LambornHill'} />
                    </picture>
                  </div>
                  :
                  (
                    propertyImages1 && propertyImages1.length > 0 ?
                    <div className="gatsby-image-wrapper featured-image fromalg">
                      <picture >
                        <ShowProcessedImage images={propertyImages1 && propertyImages1[0]} attr={{ className: 'mb-0 img-fluid', alt: location + ' - LambornHill'}} transforms={imageConfig.property.searchResults.sizes} />
                      </picture>
                    </div>
                    :
                    <div className="gatsby-image-wrapper featured-image fromalg2">
                      <picture >
                        <img src={NoImage} alt= {location + ' - LambornHill'} />
                      </picture>
                    </div>
                  )
                }
                </Link>
                {
                  noResulttag === "noResultsProperty" ? 
                  <div className="video-placeholder">
                    <picture >
                      <img src={propertyImages1 && propertyImages1[1] && propertyImages1[1]?.url} alt= {location + ' - LambornHill'} />
                    </picture>
                  </div>
                  :
                  (
                  propertyImages2 && propertyImages2[0] && propertyImages2[0].length !=0 ?
                  <VideoPlaceholder
                    videoTour2={propertyVideo}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    // image={
                    //   data.allFile.edges[0].node.childrenImageSharp[0].fluid.src
                    // }
                    image={propertyImages2 && propertyImages2[0] && propertyImages2[0]['210x140']}
                    propertyLink={propertyDetailsLink}
                   
                  />
                  :
                  <div className="gatsby-image-wrapper second-image">
                    <picture >
                      <img src={NoImage} alt= {location + ' - LambornHill'} />
                    </picture>
                  </div>
                  )
                }
                
                {
                  noResulttag === "noResultsProperty" ? 
                  <div className="gatsby-image-wrapper second-image">
                    <picture >
                      <img src={propertyImages1 && propertyImages1[2] && propertyImages1[2]?.url} alt= {location + ' - LambornHill'} />
                    </picture>
                  </div>
                  :
                  (
                    propertyImages2 && propertyImages2[1] && propertyImages2[1].length !=0 ?
                    <div className="gatsby-image-wrapper second-image">
                      <picture >
                        <ShowProcessedImage images={propertyImages2[1]} attr={{ className: 'mb-0 img-fluid', alt: location + ' - LambornHill'}} transforms={imageConfig.property.searchResults_small.sizes} />
                      </picture>
                    </div>
                    :
                    <div className="gatsby-image-wrapper second-image">
                      <picture >
                        <img src={NoImage} alt= {location + ' - LambornHill'} />
                      </picture>
                    </div>
                  )
                }

                {
                  noResulttag === "noResultsProperty" ? 
                  <div className="gatsby-image-wrapper third-image">
                    <picture >
                      <img src={propertyImages1[3] && propertyImages1[3]?.url} alt= {location + ' - LambornHill'} />
                    </picture>
                  </div>
                  :
                  (
                    propertyImages2 && propertyImages2[2] && propertyImages2[2].length !=0 ?
                    <div className="gatsby-image-wrapper third-image">
                      <picture >
                        <ShowProcessedImage images={propertyImages2[2]} attr={{ className: 'mb-0 img-fluid', alt: location + ' - LambornHill'}} transforms={imageConfig.property.searchResults_small.sizes} />
                      </picture>
                    </div>
                    :
                    <div className="gatsby-image-wrapper third-image">
                      <picture >
                        <img src={NoImage} alt= {location + ' - LambornHill'} />
                      </picture>
                    </div>
                  )
                }
              </div>
             
            </div>

            <div className="property-item__text">
              <Link to={propertyDetailsLink}>
                <h2>{price} {propertySearchType === "lettings" ? " PCM" : ""}</h2>
                <h4>{location}</h4>
                {/* <h5>{propertyTitle}</h5> */}
              </Link>

              <div className="property-item__rooms">
                {
                  bedroomsCount > 0 &&
                  <div className="property-item__room">
                    <i className="icon-bed"></i>
                    <span>{bedroomsCount} {bedroomsCount > 1 ? "Bedrooms" : "Bedroom"}</span>
                  </div>
                }

                {
                  bathroomsCount > 0 &&
                  <div className="property-item__room bath">
                    <i className="icon-bathroom"></i>
                    <span className="long">{bathroomsCount} {bathroomsCount > 1 ? "Bathrooms" : "Bathroom"}</span>
                    <span className="short">{bathroomsCount} {bathroomsCount > 1 ? "Baths" : "Bath"}</span>
                  </div>
                }

                {
                  receptionsCount > 0 &&
                  <div className="property-item__room reception">
                    <i className="icon-reception"></i>
                    <span>{receptionsCount} {receptionsCount > 1 ? "Receptions" : "Reception"}</span>
                  </div>
                }
              </div>

              <div className="property-item__description">
                <p dangerouslySetInnerHTML={{ __html: text_truncate(description) }} />
              </div>

              <div className="property-item__actions">
                <Link to={propertyDetailsLink}>
                  <span>View Details</span>
                  <i className="icon-arrow-right"></i>
                </Link>
                {status != "Sold Subject To Contract" && status != "Let Agreed" &&
                <Link to={`/book-a-viewing?pid=${propertyid}`}>
                  <span>Book a Viewing</span>
                  <i className="icon-arrow-right"></i>
                </Link>
                }
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default PropertyItem
